var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"text-center bowl"},[_c('font-awesome-layers',[_c('font-awesome-icon',{staticClass:"glow",attrs:{"icon":"circle","transform":"grow-8"}}),_vm._v(" "),_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":['fas', 'trophy'],"transform":"shrink-2 left-1"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }